(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-cart-conditie"] && !Shopify.designMode) return;
  try {
    
  /* Conditie wisselen (G11, 26-09-2026). Verplaatst elke rij naar de regel van de bewaker en wisselt op verzoek de
     variant: verse /cart.js, dan /cart/add.js (nieuwe variant, zelfde aantal, zelfde eigenschappen met stempel), dan
     /cart/change.js (oude sleutel op 0), dan herladen. Zelfde grenzen als de herstelroute van
     sections/er-native-advisory-cart.liquid: tijdslimiet per verzoek, waakhond, terugdraaien op een verse stand, en
     Afrekenen dicht via de vlag readding + refresh() van de bewaker. De bewaker zelf wordt niet gewijzigd. */
  if (!customElements.get('er-cart-conditie')) {
    class ERCartConditie extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.pending = false;
        this.onChange = (event) => {
          const select = event.target instanceof Element ? event.target.closest('[data-er-cs-select]') : null;
          if (!select) return;
          this.switchLine(select);
        };
        this.onPageShow = (event) => {
          if (!event.persisted) return;
          this.rows().forEach((row) => {
            const select = row.querySelector('[data-er-cs-select]');
            if (select && !this.pending) select.value = row.dataset.erCsVariant || '';
          });
        };
        window.addEventListener('pageshow', this.onPageShow);
        const place = () => this.place();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place, { once: true });
        else place();
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
        window.clearTimeout(this.timer);
        this.bound = false;
      }

      // Alle rijen van deze sectie, ook de rijen die al in een regel van de bewaker staan.
      rows() {
        return Array.from(document.querySelectorAll('[data-er-cs-line]'));
      }

      guard() {
        return document.querySelector('er-native-advisory-cart');
      }

      designMode() {
        return !!(window.Shopify && window.Shopify.designMode);
      }

      norm(text) {
        return String(text || '').replace(/\s+/g, ' ').trim();
      }

      // Rij N hoort bij regel N van de bewaker: het aantalveld heet daar NativeCartQuantity-N en de productnaam moet
      // gelijk zijn. Klopt dat niet (andere opbouw van de bewaker), dan blijft de rij hier als lijst staan.
      place() {
        let left = 0;
        this.querySelectorAll('[data-er-cs-line]').forEach((row) => {
          const select = row.querySelector('[data-er-cs-select]');
          if (select && !select.erCsBound) {
            select.erCsBound = true;
            select.addEventListener('change', this.onChange);
          }
          const field = document.getElementById(`NativeCartQuantity-${row.dataset.erCsLine}`);
          const line = field ? field.closest('.er-native-cart__line') : null;
          const anchor = line ? line.querySelector('.er-native-cart__variant') : null;
          const name = line ? line.querySelector('.er-native-cart__name') : null;
          const same = !!name && this.norm(name.textContent) === this.norm(row.dataset.erCsTitle);
          if (!anchor || !same || line.querySelector('[data-er-cs-line]')) {
            left += 1;
            return;
          }
          anchor.insertAdjacentElement('afterend', row);
          const title = row.querySelector('[data-er-cs-naam]');
          if (title) title.hidden = true;
          row.hidden = false;
        });
        if (left > 0) {
          this.querySelectorAll('[data-er-cs-line]').forEach((row) => { row.hidden = false; });
          this.hidden = false;
        }
      }

      endpoint(value, suffix) {
        let url;
        try {
          url = new URL(value || '', window.location.origin);
        } catch (error) {
          return null;
        }
        if (url.origin !== window.location.origin || !url.pathname.endsWith(suffix) || url.search || url.hash) return null;
        return url.href;
      }

      post(url, payload, ms) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), ms);
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
          signal: controller.signal,
        }).finally(() => window.clearTimeout(timer));
      }

      timedOut(error) {
        return !!(error && error.name === 'AbortError');
      }

      // Verse stand van de winkelwagen; null bij elke storing, en dan wordt niets op een gok gewijzigd.
      async cart(url, ms) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), ms);
        try {
          const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal });
          if (!response.ok) return null;
          const data = await response.json();
          return data && Array.isArray(data.items) ? data : null;
        } catch (error) {
          return null;
        } finally {
          window.clearTimeout(timer);
        }
      }

      async describe(response) {
        try {
          const data = await response.json();
          return data && typeof data.description === 'string' ? data.description.trim() : '';
        } catch (error) {
          return '';
        }
      }

      stamped(item) {
        return !!(item && item.properties && item.properties._er_native_route === 'er-native-advisory/1');
      }

      // De gestempelde regel van een variant (sleutel + aantal); 0 als hij er niet is.
      look(cart, variantId) {
        const line = cart.items.find((item) => item && String(item.variant_id) === variantId && this.stamped(item)) || null;
        return { key: line ? line.key : '', quantity: line ? Number(line.quantity) || 0 : 0 };
      }

      dirty() {
        return Array.from(document.querySelectorAll('er-native-advisory-cart [name="updates[]"]')).some((field) => field.value !== field.defaultValue);
      }

      busy() {
        const guard = this.guard();
        return !!(guard && (guard.readding === true || guard.saving === true)) || this.dirty();
      }

      // Afrekenen en de snelle betaalknoppen dicht zolang de nieuwe regel naast de oude kan staan: dezelfde vlag en
      // dezelfde refresh() als de herstelroute van de bewaker. Zonder bewaker-script: de knoppen zelf op slot.
      lock(on) {
        const guard = this.guard();
        if (guard && typeof guard.refresh === 'function') {
          guard.readding = on;
          guard.refresh();
          return;
        }
        document.querySelectorAll('[data-native-checkout-form] [name="checkout"]').forEach((button) => {
          if (on) {
            button.erCsWasDisabled = button.disabled;
            button.disabled = true;
          } else {
            button.disabled = !!button.erCsWasDisabled;
          }
        });
        document.querySelectorAll('[data-native-express]').forEach((express) => {
          express.classList.toggle('is-locked', on);
          if (on) express.setAttribute('inert', '');
          else express.removeAttribute('inert');
        });
      }

      async switchLine(select) {
        const row = select.closest('[data-er-cs-line]');
        if (!row) return;
        const status = row.querySelector('[data-er-cs-status]');
        const tell = (text) => { if (status) status.textContent = text || ''; };
        const revert = () => { select.value = row.dataset.erCsVariant || ''; };
        const newId = select.value;
        const oldId = row.dataset.erCsVariant || '';
        const key = row.dataset.erCsKey || '';
        const quantity = Number(row.dataset.erCsQuantity);
        if (this.designMode() || !/^[1-9][0-9]*$/.test(newId) || !Number.isSafeInteger(Number(newId)) || newId === oldId) { revert(); return; }
        if (this.pending || this.busy()) { revert(); tell(this.dataset.wait); return; }
        const addUrl = this.endpoint(this.dataset.addUrl, '/cart/add.js');
        const changeUrl = this.endpoint(this.dataset.changeUrl, '/cart/change.js');
        const cartUrl = changeUrl ? changeUrl.replace(/\/cart\/change\.js$/, '/cart.js') : null;
        if (!addUrl || !changeUrl || !cartUrl || key === '' || !Number.isSafeInteger(quantity) || quantity < 1) { revert(); return; }
        let properties = {};
        try {
          const parsed = JSON.parse(row.dataset.erCsProperties || '{}');
          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) properties = parsed;
        } catch (error) {
          properties = {};
        }
        properties._er_native_route = 'er-native-advisory/1';

        this.pending = true;
        select.disabled = true;
        row.setAttribute('aria-busy', 'true');
        tell(this.dataset.busy);
        this.lock(true);
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => window.location.reload(), 45000);

        const finish = (outcome, text) => {
          window.clearTimeout(this.timer);
          if (outcome === 'reload') { window.location.reload(); return; }
          this.pending = false;
          row.removeAttribute('aria-busy');
          tell(text);
          if (outcome === 'duplicate') return; // slot blijft dicht tot de klant een regel weghaalt (herlaadbeurt)
          select.disabled = false;
          revert();
          this.lock(false);
        };

        try {
          const before = await this.cart(cartUrl, 8000);
          if (!before) throw new Error('');
          const old = before.items.find((item) => item && item.key === key) || null;
          if (!old || Number(old.quantity) !== quantity || String(old.variant_id) !== oldId) { finish('reload'); return; }
          const newBefore = this.look(before, newId).quantity;

          let added = null;
          try {
            added = await this.post(addUrl, { items: [{ id: Number(newId), quantity, properties }] }, 8000);
          } catch (error) {
            if (!this.timedOut(error)) throw error;
          }
          if (added && !added.ok) throw new Error(await this.describe(added));
          if (!added) {
            // Toevoegen na 8 seconden afgebroken: een verse stand beslist of het is geland.
            const now = await this.cart(cartUrl, 8000);
            if (!now || this.look(now, newId).quantity - newBefore < quantity) throw new Error('');
          }

          let gone = false;
          let removed = null;
          try {
            removed = await this.post(changeUrl, { id: key, quantity: 0 }, 8000);
          } catch (error) {
            removed = null;
          }
          if (removed && removed.ok) {
            try {
              const data = await removed.json();
              gone = !!data && Array.isArray(data.items) && !data.items.some((item) => item && item.key === key);
            } catch (error) {
              gone = false;
            }
          }
          if (!gone) {
            const now = await this.cart(cartUrl, 8000);
            if (now && !now.items.some((item) => item && item.key === key)) {
              gone = true;
            } else if (now) {
              // De oude regel staat er nog: de toevoeging terugdraaien (uitkomst min toegevoegd, nooit onder 0).
              const seen = this.look(now, newId);
              if (seen.key !== '') {
                let back = null;
                try {
                  back = await this.post(changeUrl, { id: seen.key, quantity: Math.max(0, seen.quantity - quantity) }, 8000);
                } catch (error) {
                  back = null;
                }
                if (back && back.ok) { finish('failed', this.dataset.failed); return; }
              }
              finish('duplicate', this.dataset.double);
              return;
            } else {
              finish('duplicate', this.dataset.double);
              return;
            }
          }
          finish('reload');
        } catch (error) {
          const reason = error instanceof Error && error.message ? ` ${error.message}` : '';
          finish('failed', `${this.dataset.failed || ''}${reason}`.trim());
        }
      }
    }

    customElements.define('er-cart-conditie', ERCartConditie);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-cart-extra"] && !Shopify.designMode) return;
  try {
    
  /* Ronde I, I2.61 (27-09-2026): A-nummer en opmerking slaan zichzelf op (uitleg bovenaan dit bestand). Alleen
     /cart/update.js met attributes of note: de regels, aantallen en de bewaker worden niet aangeraakt. */
  (() => {
    const bind = () => {
      document.querySelectorAll('[data-er-ce-form]').forEach((form) => {
        if (form.erCeBound) return;
        form.erCeBound = true;
        const url = form.dataset.updateUrl || '';
        if (!url.endsWith('/cart/update.js')) return;
        const key = form.dataset.key || 'A-nummer';
        const number = form.querySelector('[data-er-ce-number]');
        const note = form.querySelector('[data-er-ce-note]');
        const status = form.querySelector('[data-er-ce-status]');
        const box = form.closest('.er-cart-extra__box');
        const summary = box ? box.querySelector('.er-cart-extra__summary-text') : null;
        const current = () => ({ number: number ? number.value.trim() : null, note: note ? note.value : null });
        // o12 (KRITIEK-RONDE-O6 #1): de stand die echt op de wagen staat, vóór het invullen hieronder; de samenvatting na een opslag
        // toont alleen wat werkelijk meeging.
        const opgeslagen = current();
        // o11 (ronde O, 09-10-2026, KRITIEK-RONDE-O4 #1): typte de klant eerder in deze sessie een herkend modelnummer (er-model-input
        // of de zoekpagina), dan staat dat nummer hier alvast in het lege veld en gaat het blok open. Opslaan doet de klant zelf (knop,
        // of het veld aanpassen); daarom vóór saved = current(), zodat pagehide het niet ongevraagd opslaat.
        if (number && !number.value.trim()) {
          let eerder = '';
          try {
            eerder = window.sessionStorage.getItem('er-a-nummer') || '';
          } catch (error) {
            eerder = '';
          }
          if (/^A[0-9]{4}$/.test(eerder)) {
            number.value = eerder;
            if (box) box.open = true;
          }
        }
        let saved = current();
        let timer = 0;
        // Dezelfde regels als de Liquid: A + vier cijfers -> belofte; andere invoer -> neutrale regel; alleen een
        // opmerking -> die regel; niets -> de gesloten regel.
        const line = (state) => {
          if (state.number) {
            const nr = state.number.toUpperCase();
            return /^A[0-9]{4}/.test(nr)
              ? (form.dataset.summarySaved || '').replace('[waarde]', nr)
              : (form.dataset.summaryNeutral || '').replace('[waarde]', state.number);
          }
          return state.note && state.note.trim() ? form.dataset.summaryNote || '' : form.dataset.summaryClosed || '';
        };
        const save = (leaving) => {
          window.clearTimeout(timer);
          const now = current();
          const payload = {};
          if (number && now.number !== saved.number) payload.attributes = { [key]: now.number };
          if (note && now.note !== saved.note) payload.note = now.note;
          if (!Object.keys(payload).length) return;
          const before = saved;
          saved = now;
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
            keepalive: !!leaving,
          })
            .then((response) => {
              if (!response.ok) throw new Error(String(response.status));
              // o12 (KRITIEK-RONDE-O6 #1): alleen wat echt meeging telt als opgeslagen.
              if (payload.attributes) {
                opgeslagen.number = now.number;
                if (!now.number) {
                  try {
                    window.sessionStorage.removeItem('er-a-nummer');
                  } catch (error) {
                    // Opslag geblokkeerd: niets te wissen.
                  }
                }
              }
              if ('note' in payload) opgeslagen.note = now.note;
              if (summary) summary.textContent = line(opgeslagen);
              if (status) {
                status.textContent = now.number && now.number !== opgeslagen.number
                  ? form.dataset.savedNoteOnly || form.dataset.saved || ''
                  : form.dataset.saved || '';
              }
            })
            .catch(() => {
              if (saved === now) saved = before;
              if (status) status.textContent = form.dataset.failed || '';
            });
        };
        [number, note].forEach((field) => {
          if (!field) return;
          field.addEventListener('input', () => {
            window.clearTimeout(timer);
            if (status) status.textContent = '';
            timer = window.setTimeout(() => save(false), 800);
          });
          // change vuurt bij het verlaten van het veld, dus vóór een klik op Verwijderen, Bijwerken of Afrekenen.
          field.addEventListener('change', () => save(true));
        });
        window.addEventListener('pagehide', () => save(true));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
    else bind();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-cart-upsell')) {
    class ERCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.pending = false;
        this.status = this.querySelector('[data-er-cart-upsell-status]');
        this.onClick = (event) => {
          const button = event.target.closest('[data-er-cart-upsell-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.addToCart(button);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        this.bound = false;
      }

      endpoint() {
        let url;
        try {
          url = new URL(this.getAttribute('data-add-url') || '/cart/add.js', window.location.origin);
        } catch (error) {
          return null;
        }
        if (url.origin !== window.location.origin || !url.pathname.endsWith('/cart/add.js') || url.search || url.hash) return null;
        return url.href;
      }

      say(text) {
        if (this.status) this.status.textContent = text;
      }

      async addToCart(button) {
        const variantId = button.getAttribute('data-er-variant-id') || '';
        const endpoint = this.endpoint();
        if (this.pending || !endpoint || !/^[1-9][0-9]*$/.test(variantId) || !Number.isSafeInteger(Number(variantId))) return;
        // Review 18-09 (B1): eerst een gewijzigd aantal laten opslaan, anders gaat die wijziging bij het herladen verloren.
        const cartEl = document.querySelector('er-native-advisory-cart');
        const dirty = !!cartEl && (cartEl.saving || Array.from(cartEl.querySelectorAll('[name="updates[]"]')).some((field) => field.value !== field.defaultValue));
        if (dirty) {
          const saving = cartEl.querySelector('[data-native-cart-status]');
          this.say(saving ? saving.dataset.saving || '' : '');
          return;
        }
        this.pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.say('');

        const body = { id: Number(variantId), quantity: 1, properties: { _er_native_route: 'er-native-advisory/1' } };
        let message = this.dataset.error || '';
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          if (response.ok) {
            window.location.reload();
            return;
          }
          try {
            const data = await response.json();
            if (data && typeof data.description === 'string' && data.description.trim() !== '') message = data.description;
          } catch (error) {
            // geen JSON-body: de standaardmelding blijft staan
          }
        } catch (error) {
          // netwerkfout: de standaardmelding blijft staan
        }
        this.pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        this.say(`${message} ${this.dataset.uncertain || ''}`.trim());
      }
    }

    customElements.define('er-cart-upsell', ERCartUpsell);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-case-cards"] && !Shopify.designMode) return;
  try {
    
  /* Snel toevoegen op de modelkaarten (21-09-2026, concurrentiepunt 13). Regel voor regel dezelfde route
     als sections/er-cart-upsell.liquid: adrescontrole, dezelfde body met _er_native_route, dezelfde
     foutmeldingen in de aria-live-regel, en bij HTTP 200 dezelfde bevestiging (de pagina herlaadt).
     Alleen de namen zijn anders. Er wordt niets aan het formulier, de select of de gate gewijzigd. */
  if (!customElements.get('er-case-cards')) {
    class ERCaseCards extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.pending = false;
        this.status = this.querySelector('[data-er-case-cards-status]');
        this.onClick = (event) => {
          const button = event.target.closest('[data-er-case-cards-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.addToCart(button);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        this.bound = false;
      }

      endpoint() {
        let url;
        try {
          url = new URL(this.getAttribute('data-add-url') || '/cart/add.js', window.location.origin);
        } catch (error) {
          return null;
        }
        if (url.origin !== window.location.origin || !url.pathname.endsWith('/cart/add.js') || url.search || url.hash) return null;
        return url.href;
      }

      say(text) {
        if (this.status) this.status.textContent = text;
      }

      async addToCart(button) {
        const variantId = button.getAttribute('data-er-variant-id') || '';
        const endpoint = this.endpoint();
        if (this.pending || !endpoint || !/^[1-9][0-9]*$/.test(variantId) || !Number.isSafeInteger(Number(variantId))) return;
        this.pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.say('');

        const body = { id: Number(variantId), quantity: 1, properties: { _er_native_route: 'er-native-advisory/1' } };
        let message = this.dataset.error || '';
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          if (response.ok) {
            window.location.reload();
            return;
          }
          try {
            const data = await response.json();
            if (data && typeof data.description === 'string' && data.description.trim() !== '') message = data.description;
          } catch (error) {
            // geen JSON-body: de standaardmelding blijft staan
          }
        } catch (error) {
          // netwerkfout: de standaardmelding blijft staan
        }
        this.pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        this.say(`${message} ${this.dataset.uncertain || ''}`.trim());
      }
    }

    customElements.define('er-case-cards', ERCaseCards);
  }

  /* 23-10-2026 (ronde W, w6 = W2.2c; W21-NULMETING W3): de schakelaar. Rijen met een 'Label in de schakelaar' (data-er-tab op
     .er-cases) die direct onder elkaar staan, worden één rij met een schakelaar erboven: de bovenste rij staat open, de andere
     krijgen hidden tot de klant ze kiest. De balk neemt de kleur van de open rij. De keuze blijft binnen het tabblad bewaard
     (sessionStorage), zodat de terugknop dezelfde rij toont. Zonder JavaScript, in de thema-editor of met minder dan twee rijen
     verandert er niets. Kaarten, knoppen en links blijven ongewijzigd in de pagina. */
  (function () {
    if (window.erCasesSchakel) return;
    window.erCasesSchakel = true;

    function kern(sectie) {
      if (!sectie || !sectie.classList || !sectie.classList.contains('shopify-section')) return null;
      var el = sectie.querySelector('.er-cases[data-er-tab]');
      return el && el.parentElement === sectie && el.getAttribute('data-er-tab') ? el : null;
    }

    function groep(leden) {
      var sleutel = 'er-cases-schakel:' + leden[0].sectie.id;
      var balk = document.createElement('div');
      var binnen = document.createElement('div');
      var knoppen = document.createElement('div');
      binnen.className = 'er-cases-schakel__inner page-width';
      knoppen.className = 'er-cases-schakel__knoppen';
      knoppen.setAttribute('role', 'group');
      knoppen.setAttribute('aria-label', leden[0].kern.getAttribute('data-er-tab-groep') || '');

      function kies(open) {
        leden.forEach(function (lid, index) {
          var dicht = index !== open;
          lid.knop.setAttribute('aria-pressed', dicht ? 'false' : 'true');
          lid.sectie.hidden = dicht;
          if (dicht) {
            lid.sectie.setAttribute('data-er-tab-dicht', '');
          } else {
            lid.sectie.removeAttribute('data-er-tab-dicht');
          }
        });
        var kleur = Array.prototype.filter.call(leden[open].kern.classList, function (naam) {
          return naam.indexOf('color-') === 0;
        });
        balk.className = ['er-cases-schakel', 'gradient'].concat(kleur).join(' ');
      }

      leden.forEach(function (lid, index) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'er-cases-schakel__knop';
        knop.textContent = lid.kern.getAttribute('data-er-tab');
        knop.setAttribute('aria-controls', lid.sectie.id);
        knop.addEventListener('click', function () {
          kies(index);
          try {
            window.sessionStorage.setItem(sleutel, String(index));
          } catch (error) {
            // geen opslag (privévenster): de keuze geldt dan alleen voor deze pagina
          }
        });
        lid.knop = knop;
        knoppen.appendChild(knop);
      });
      binnen.appendChild(knoppen);
      balk.appendChild(binnen);
      leden[0].sectie.parentNode.insertBefore(balk, leden[0].sectie);

      var bewaard = 0;
      try {
        var waarde = parseInt(window.sessionStorage.getItem(sleutel) || '0', 10);
        if (waarde >= 0 && waarde < leden.length) bewaard = waarde;
      } catch (error) {
        // geen opslag: de bovenste rij staat open
      }
      kies(bewaard);
    }

    function bouw() {
      if (window.Shopify && window.Shopify.designMode) return;
      var gezien = [];
      document.querySelectorAll('.er-cases[data-er-tab]').forEach(function (start) {
        var sectie = start.parentElement;
        if (!kern(sectie) || gezien.indexOf(sectie) !== -1) return;
        var leden = [];
        while (kern(sectie)) {
          gezien.push(sectie);
          leden.push({ sectie: sectie, kern: kern(sectie) });
          sectie = sectie.nextElementSibling;
        }
        if (leden.length < 2 || leden.some(function (lid) { return !lid.sectie.id; })) return;
        groep(leden);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bouw);
    } else {
      bouw();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-catalog-review"]) return;
  try {
    
  if (!customElements.get('er-native-catalog-review')) {
    customElements.define('er-native-catalog-review', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.select = this.querySelector('[data-er-review-select]');
        if (!this.select) return;
        this.select.value = '';
        this.onSelectionChange = () => this.renderSelection();
        this.select.addEventListener('change', this.onSelectionChange);
        this.renderSelection();
      }

      disconnectedCallback() {
        if (this.select && this.onSelectionChange) {
          this.select.removeEventListener('change', this.onSelectionChange);
        }
      }

      renderSelection() {
        const panels = Array.from(this.querySelectorAll('[data-er-review-details]'));
        const prompt = this.querySelector('[data-er-review-prompt]');
        panels.forEach((panel) => { panel.hidden = true; });
        if (!prompt) return;
        prompt.hidden = false;
        const productId = this.dataset.productId;
        const variantId = this.select?.value;
        if (!/^[1-9][0-9]*$/.test(productId || '') || productId !== this.dataset.pageProductId) return;
        if (!/^[1-9][0-9]*$/.test(variantId || '')) return;
        const options = Array.from(this.select.options).filter((option) => option.value === variantId);
        const matches = panels.filter((panel) => panel.dataset.variantId === variantId);
        if (options.length !== 1 || matches.length !== 1 || matches[0].dataset.productId !== productId) return;
        matches[0].hidden = false;
        prompt.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-generation-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-generation-selector')) {
    class ERGenerationSelector extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-er-slider]');
        this.dots = this.querySelector('[data-er-dots]');
        if (!this.slider || !this.dots) return;

        this.onScroll = () => window.requestAnimationFrame(() => this.updateDots());
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.buildDots());
          this.resizeObserver.observe(this.slider);
        }

        this.buildDots();
      }

      disconnectedCallback() {
        if (this.slider && this.onScroll) this.slider.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      pageCount() {
        const width = this.slider.clientWidth;
        if (!width || this.slider.scrollWidth <= width + 1) return 0;
        return Math.ceil(this.slider.scrollWidth / width);
      }

      buildDots() {
        const pages = this.pageCount();
        if (pages === this.dots.childElementCount) {
          this.updateDots();
          return;
        }

        this.dots.textContent = '';
        this.dots.hidden = pages < 2;
        const label = this.getAttribute('data-er-dot-label') || '';

        for (let index = 0; index < pages; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'er-generation-selector__dot';
          dot.setAttribute('aria-label', (label + ' ' + (index + 1)).trim());
          dot.addEventListener('click', () => {
            // 03-10-2026 (ronde J, j2a): 'verminder beweging' volgen.
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.slider.scrollTo({ left: index * this.slider.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
          });
          this.dots.appendChild(dot);
        }

        this.updateDots();
      }

      updateDots() {
        const dots = Array.from(this.dots.children);
        if (!dots.length) return;
        const width = this.slider.clientWidth || 1;
        const index = Math.min(dots.length - 1, Math.round(this.slider.scrollLeft / width));
        dots.forEach((dot, position) => {
          dot.classList.toggle('is-active', position === index);
          // 30-10-2026 (ronde AB, ab-q1; toegankelijkheidsaudit T10/S9, WCAG 4.1.2): de huidige stip ook voor hulpmiddelen, niet alleen
          // in kleur.
          if (position === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('er-generation-selector', ERGenerationSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-model-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-model-finder')) {
    class ERModelFinder extends HTMLElement {
      connectedCallback() {
        if (this.erReady) {
          this.showStep(1, false);
          return;
        }
        this.erReady = true;
        this.stepPanels = Array.from(this.querySelectorAll('[data-er-step-panel]'));
        this.modelPanels = Array.from(this.querySelectorAll('[data-er-models]'));
        this.progress = this.querySelector('[data-er-progress]');

        this.querySelectorAll('[data-er-part]').forEach((part) => {
          part.addEventListener('click', (event) => {
            event.preventDefault();
            this.showPart(part.getAttribute('data-er-part'));
          });
        });

        this.querySelectorAll('[data-er-reset]').forEach((button) => {
          button.addEventListener('click', () => this.showStep(1, true));
        });

        this.classList.add('er-model-finder--ready');
        this.showStep(1, false);
      }

      showPart(index) {
        this.modelPanels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-er-models') === index);
        });
        this.showStep(2, true);
      }

      showStep(step, moveFocus) {
        const key = String(step);
        this.setAttribute('data-er-step', key);
        this.stepPanels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-er-step-panel') === key);
        });
        if (this.progress) {
          this.progress.style.width = key === '2' ? '100%' : '50%';
        }
        if (moveFocus) {
          const target = this.querySelector('[data-er-step-panel="' + key + '"] [data-er-focus]');
          if (target) target.focus();
        }
      }
    }

    customElements.define('er-model-finder', ERModelFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-native-advisory-cart"]) return;
  try {
    
  if (!customElements.get('er-native-advisory-cart')) {
    customElements.define('er-native-advisory-cart', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[name="checkout"]');
        this.form = this.querySelector('[data-native-checkout-form]');
        this.updateForm = this.querySelector('[data-native-update-form]');
        if (!this.updateForm && !this.form) return;
        this.abort?.abort();
        this.abort = new AbortController();
        // GX (18-09): extra grepen voor B1/B4. De twee submit-guards en de dirty-regel in refresh() zijn ongewijzigd.
        this.express = this.querySelector('[data-native-express]');
        this.status = this.querySelector('[data-native-cart-status]');
        this.saving = false;
        this.readding = false;
        // 22-09: true zodra een herstelpoging het onderdeel opnieuw heeft toegevoegd maar de oude regel niet
        // kwijt kon. Dan staat hetzelfde onderdeel twee keer in de winkelwagen en blijven Afrekenen en de
        // snelle betaalknoppen dicht tot de klant de rood gemarkeerde regel weghaalt (anders reken je dubbel af).
        this.duplicate = false;
        this.addEventListener('input', () => this.refresh(), { signal: this.abort.signal });
        this.updateForm?.addEventListener('submit', (event) => {
          if (this.dataset.commerceVersion !== 'er-native-advisory/1' || this.dataset.previewOnly !== 'false') event.preventDefault();
        }, { signal: this.abort.signal });
        this.form?.addEventListener('submit', (event) => {
          this.refresh();
          if (!this.button || this.button.disabled) event.preventDefault();
        }, { signal: this.abort.signal });
        // B4: een gewijzigd aantal na ~700 ms opslaan via het bestaande bijwerkformulier; ook bij handmatig
        // Bijwerken blijft alles vergrendeld tot de pagina opnieuw geladen is.
        this.updateForm?.addEventListener('input', (event) => this.scheduleSave(event, 1500), { signal: this.abort.signal });
        // Review 18-09 (B1): bij verlaten van het veld of de pijltjes (change) sneller opslaan dan tijdens het typen.
        this.updateForm?.addEventListener('change', (event) => this.scheduleSave(event, 400), { signal: this.abort.signal });
        try {
          const back = window.sessionStorage.getItem('er-cart-focus');
          if (back) {
            window.sessionStorage.removeItem('er-cart-focus');
            const field = document.getElementById(back);
            if (field && this.contains(field)) field.focus({ preventScroll: false });
          }
        } catch (error) {
          // sessionStorage niet beschikbaar: geen focusherstel
        }
        this.updateForm?.addEventListener('submit', (event) => {
          if (event.defaultPrevented) return;
          window.clearTimeout(this.timer);
          this.saving = true;
          this.say(this.status?.dataset.saving || '');
          this.refresh();
        }, { signal: this.abort.signal });
        // B1: "Opnieuw toevoegen" bestaat alleen met script. Herstel-2 (18-09): ook in de voorvertoning van een
        // niet-gepubliceerd thema (data-preview-only="true"), zodat de herstelroute vóór publicatie te testen is; de
        // knop herstelt alleen een bestaande winkelwagenregel en maakt geen bestelling aan. Niet in de thema-editor.
        this.addEventListener('click', (event) => {
          const button = event.target instanceof Element ? event.target.closest('[data-native-readd]') : null;
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.readd(button);
        }, { signal: this.abort.signal });
        // 22-09 (tabbladen): met script haalt "Verwijder deze regel" de regel weg op SLEUTEL (/cart/change.js met
        // de key) in plaats van op regelnummer via de link (url_to_remove, ?line=N). Reden: loopt deze pagina achter
        // omdat een ander tabblad de regel al heeft vernieuwd, dan wijst regelnummer N inmiddels naar een ANDERE
        // regel - het herstelde onderdeel - en zou juist dat verdwijnen. Een sleutel die niet meer bestaat geeft
        // 404: dan valt er niets te verwijderen en laat de herlaadbeurt de echte stand zien. Zonder script blijft
        // de link precies wat hij was.
        this.addEventListener('click', (event) => {
          const link = event.target instanceof Element ? event.target.closest('[data-native-legacy-block] a[href]') : null;
          if (!link || !this.contains(link) || !/\/cart\/change(\?|$)/.test(link.getAttribute('href') || '')) return;
          event.preventDefault();
          this.removeLegacy(link);
        }, { signal: this.abort.signal });
        if (!this.designMode()) {
          this.querySelectorAll('[data-native-readd]').forEach((button) => { button.hidden = false; });
        }
        // Terug via de browsercache (bfcache): niet-opgeslagen aantallen terug op de opgeslagen stand.
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted && !this.fields().some((field) => field.value !== field.defaultValue)) return;
          window.clearTimeout(this.timer);
          this.saving = false;
          this.updateForm?.reset();
          this.say('');
          this.refresh();
        }, { signal: this.abort.signal });
        this.refresh();
        this.autoReadd();
      }
      disconnectedCallback() { this.abort?.abort(); window.clearTimeout(this.timer); window.clearTimeout(this.readdTimer); }
      // Herstel-2: alleen de thema-editor (Shopify.designMode) sluit de hersteltoetsen uit; de voorvertoning niet.
      designMode() {
        return !!(window.Shopify && window.Shopify.designMode);
      }
      refresh() {
        if (!this.button) return;
        const dirty = Array.from(this.querySelectorAll('[name="updates[]"]')).some((input) => input.value !== input.defaultValue);
        // 22-09: de dirty-regel en de drie dataset-controles zijn ongewijzigd; er komen twee redenen bij om te
        // wachten (een lopende herstelpoging en een half gelukte herstelpoging). Er verdwijnt geen enkele reden.
        const busy = dirty || this.readding || this.duplicate;
        this.button.disabled = busy || this.dataset.commerceVersion !== 'er-native-advisory/1' || this.dataset.allowed !== 'true' || this.dataset.previewOnly !== 'false';
        this.lock(busy || this.saving);
      }
      // B4: snelle betaalknoppen (Shop Pay, PayPal, Google Pay) niet klikbaar zolang een aantal gewijzigd of nog
      // niet opgeslagen is; ze rekenen anders af met het oude aantal. inert waar de browser het kent, de klasse
      // dekt oudere browsers met pointer-events: none.
      lock(locked) {
        if (!this.express) return;
        this.express.classList.toggle('is-locked', locked);
        if (locked) this.express.setAttribute('inert', '');
        else this.express.removeAttribute('inert');
      }
      say(text) {
        if (this.status) this.status.textContent = text;
      }
      fields() {
        return Array.from(this.querySelectorAll('[name="updates[]"]'));
      }
      valid(fields) {
        return fields.every((field) => field.value !== '' && field.checkValidity() && Number(field.value) >= 1);
      }
      // B4: alleen een geldig aantal van minstens 1 wordt automatisch opgeslagen. Aantal 0 (verwijderen), leeg of
      // ongeldig blijft handmatig: Bijwerken of de link Verwijderen. Tot dan blijft alles vergrendeld (refresh).
      scheduleSave(event, delay = 1500) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'updates[]') return;
        window.clearTimeout(this.timer);
        if (this.saving || this.dataset.commerceVersion !== 'er-native-advisory/1' || this.dataset.previewOnly !== 'false') return;
        const fields = this.fields();
        this.say('');
        if (!fields.some((field) => field.value !== field.defaultValue) || !this.valid(fields)) return;
        this.timer = window.setTimeout(() => this.save(), delay);
      }
      save() {
        if (!this.updateForm || this.saving) return;
        if (this.dataset.commerceVersion !== 'er-native-advisory/1' || this.dataset.previewOnly !== 'false') return;
        const fields = this.fields();
        if (!fields.some((field) => field.value !== field.defaultValue) || !this.valid(fields)) return;
        this.saving = true;
        try {
          const active = document.activeElement;
          if (active instanceof HTMLInputElement && active.name === 'updates[]' && active.id) window.sessionStorage.setItem('er-cart-focus', active.id);
        } catch (error) {
          // geen focusherstel
        }
        this.say(this.status?.dataset.saving || '');
        this.refresh();
        // Dezelfde POST als de knop Bijwerken (updates[] naar de action van het formulier). requestSubmit laat de
        // submit-guard hierboven meelopen; de terugval submit() volgt op precies dezelfde controles.
        if (typeof this.updateForm.requestSubmit === 'function') this.updateForm.requestSubmit();
        else this.updateForm.submit();
      }
      endpoint(value, suffix) {
        let url;
        try {
          url = new URL(value || '', window.location.origin);
        } catch (error) {
          return null;
        }
        if (url.origin !== window.location.origin || !url.pathname.endsWith(suffix) || url.search || url.hash) return null;
        return url.href;
      }
      // 22-09 (tabbladen): de leesroute /cart.js, afgeleid van dezelfde (gecontroleerde) cart_change_url, zodat
      // een taalvoorvoegsel (/en/cart/change.js -> /en/cart.js) vanzelf meegaat. Geen nieuw data-attribuut nodig.
      cartEndpoint(changeUrl) {
        return changeUrl ? changeUrl.replace(/\/cart\/change\.js$/, '/cart.js') : null;
      }
      // 22-09 (tabbladen): elk verzoek heeft een tijdslimiet. De oude waakhond zette na 8 seconden Afrekenen en de
      // snelle betaalknoppen weer open terwijl het toevoegen en het weghalen alsnog konden landen - precies het
      // venster waarin een klant het dubbele aantal kon afrekenen. Nu breekt de tijdslimiet het verzoek zelf af, en
      // beslist daarna een verse /cart.js (settle) wat er echt is gebeurd. Knoppen gaan pas open als dat bekend is.
      post(url, payload, ms) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), ms);
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
          signal: controller.signal,
        }).finally(() => window.clearTimeout(timer));
      }
      timedOut(error) {
        return !!(error && error.name === 'AbortError');
      }
      // Verse stand van de winkelwagen (null bij elke storing: geen enkele beslissing wordt dan op een gok genomen).
      async cart(url, ms) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), ms);
        try {
          const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal });
          if (!response.ok) return null;
          const data = await response.json();
          return data && Array.isArray(data.items) ? data : null;
        } catch (error) {
          return null;
        } finally {
          window.clearTimeout(timer);
        }
      }
      stamped(item) {
        return !!(item && item.properties && item.properties._er_native_route === 'er-native-advisory/1');
      }
      // Wat een verse /cart.js zegt over de regel die hersteld wordt: staat de oude regel er nog (op sleutel), en
      // welke gestempelde regel van dezelfde variant staat ernaast (sleutel + totaal aantal). Alleen daarop wordt
      // gerekend - nooit op het antwoord van de eigen toevoeging.
      look(cart, key, variantId) {
        const old = cart.items.find((item) => item && item.key === key) || null;
        const stamped = cart.items.filter((item) => item && item.key !== key && String(item.variant_id) === variantId && this.stamped(item));
        const stampedQuantity = stamped.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
        return { old, stampedKey: stamped.length ? stamped[0].key : '', stampedQuantity };
      }
      // 22-09 (tabbladen): het merkteken staat in localStorage, dat alle tabbladen van deze winkel delen, met een
      // tijdstempel en een geldigheid van 10 minuten. sessionStorage was per tabblad: twee tabbladen met dezelfde
      // oude winkelwagen herstelden allebei, en de tweede kon de eerste ongedaan maken tot een lege winkelwagen.
      // Na het zetten wordt het merkteken na een korte, willekeurige pauze teruggelezen: schreef een ander tabblad
      // er intussen overheen, dan wint dat tabblad en doet dit tabblad niets. Is het merkteken jonger dan 30
      // seconden, dan is een ander tabblad waarschijnlijk nu bezig: dit tabblad kijkt straks alleen of zijn eigen
      // weergave nog klopt (recent). Zonder localStorage: sessionStorage zoals voorheen; zonder allebei: geen
      // automatische poging (de knoppen blijven staan).
      claim(key) {
        const name = `er-cart-autoreadd:${key}`;
        const stamp = `${Date.now()}:${Math.random().toString(36).slice(2, 10)}`;
        try {
          const raw = window.localStorage.getItem(name) || '';
          const at = Number(raw.split(':')[0]);
          if (Number.isFinite(at) && at > 0 && Date.now() - at < 600000) return Date.now() - at < 30000 ? { recent: true } : null;
          window.localStorage.setItem(name, stamp);
          return { name, stamp };
        } catch (error) {
          try {
            if (window.sessionStorage.getItem(name)) return null;
            window.sessionStorage.setItem(name, '1');
            return { name, stamp: '' };
          } catch (error2) {
            return null;
          }
        }
      }
      confirmClaim(claim) {
        if (!claim.stamp) return true;
        try {
          return window.localStorage.getItem(claim.name) === claim.stamp;
        } catch (error) {
          return true;
        }
      }
      // 22-09 (de bewaker waarschuwt): dezelfde herstelroute als de knop, maar één keer automatisch bij het
      // openen van de winkelwagen, zodat een klant met een winkelwagen van vóór 14-09 niets hoeft te doen. Geen
      // nieuwe route: het is letterlijk readd() met auto = true. Harde grenzen: één poging per regelsleutel per
      // 10 minuten over alle tabbladen heen (claim, hierboven), nooit in de thema-editor, nooit bij een gewijzigd
      // of nog niet opgeslagen aantal. Mislukt het, dan valt alles terug op de bestaande knoppen en teksten.
      async autoReadd() {
        if (this.designMode() || this.dataset.commerceVersion !== 'er-native-advisory/1') return;
        // 22-09 (ongedaan maken): staat dezelfde variant al met en zonder stempel in de winkelwagen, dan is een
        // eerdere poging half gelukt. Automatisch opnieuw toevoegen zou die twee regels samenvoegen tot een
        // regel met het dubbele aantal - en dan zou het slot van het liquid-blok wegvallen. Deze staat lost de
        // klant zelf op met "Verwijder deze regel"; ook in een nieuwe sessie, waarin het merkteken weg is.
        // 22-09 (tabbladen): of het is een achtergebleven weergave van een ander tabblad; verifyLines kijkt.
        if (this.dataset.duplicate === 'true') { this.verifyLines(1500); return; }
        if (this.readding || this.saving || this.fields().some((field) => field.value !== field.defaultValue)) return;
        const button = this.querySelector('[data-native-legacy] [data-native-readd]');
        if (!button || button.hidden || button.disabled) return;
        const line = button.closest('[data-native-legacy]');
        const key = line ? line.dataset.nativeKey || '' : '';
        if (key === '') return;
        const claim = this.claim(key);
        if (!claim) return;
        // Een ander tabblad is er net mee bezig: niets toevoegen, alleen straks kijken of deze weergave nog klopt.
        if (claim.recent) { this.verifyLines(2500); return; }
        await new Promise((resolve) => window.setTimeout(resolve, 60 + Math.floor(Math.random() * 90)));
        if (!this.confirmClaim(claim)) { this.verifyLines(2500); return; }
        if (!this.isConnected || this.readding || this.saving || this.fields().some((field) => field.value !== field.defaultValue)) return;
        this.readd(button, true);
      }
      // 22-09 (tabbladen): een weergave met een regel zonder stempel kan achterlopen op de winkelwagen: dit tabblad
      // laadde terwijl een ander tabblad (net) aan het herstellen was - met de dubbele-regelstaat (nieuwe regel al
      // in de winkelwagen, oude nog niet weg) of met een merkteken van zojuist. Eén verse /cart.js, na een korte
      // pauze zodat dat andere tabblad kan afmaken, beslist: is een van de gemarkeerde regels inmiddels weg, dan
      // herladen, want waarschuwing, slot en knoppen horen bij een stand die niet meer bestaat. Staat alles er nog,
      // dan blijft alles staan (geen herlaadlus: na een herlaadbeurt klopt de weergave weer met de winkelwagen).
      async verifyLines(delay) {
        const block = this.querySelector('[data-native-legacy-block]');
        const cartUrl = this.cartEndpoint(block ? this.endpoint(block.dataset.changeUrl, '/cart/change.js') : null);
        const keys = Array.from(this.querySelectorAll('[data-native-legacy]')).map((line) => line.dataset.nativeKey || '').filter((key) => key !== '');
        if (!cartUrl || !keys.length) return;
        await new Promise((resolve) => window.setTimeout(resolve, delay));
        if (!this.isConnected || this.readding) return;
        const now = await this.cart(cartUrl, 8000);
        if (!now || !this.isConnected || this.readding) return;
        if (keys.some((key) => !now.items.some((item) => item && item.key === key))) window.location.reload();
      }
      // 22-09 (tabbladen): "Verwijder deze regel" met script, zie de klik-handler in connectedCallback.
      async removeLegacy(link) {
        const line = link.closest('[data-native-legacy]');
        const block = link.closest('[data-native-legacy-block]');
        if (!line || !block || this.readding || this.dataset.commerceVersion !== 'er-native-advisory/1') return;
        const key = line.dataset.nativeKey || '';
        const changeUrl = this.endpoint(block.dataset.changeUrl, '/cart/change.js');
        if (key === '' || !changeUrl) { window.location.href = link.href; return; }
        const status = line.querySelector('[data-native-legacy-status]');
        this.readding = true;
        link.setAttribute('aria-busy', 'true');
        this.refresh();
        try {
          const removed = await this.post(changeUrl, { id: key, quantity: 0 }, 8000);
          if (!removed.ok) {
            // Geweigerd (404 bij een sleutel die al weg is, of iets anders): een verse stand beslist. Is de regel
            // weg, dan is er niets meer te doen en toont de herlaadbeurt de winkelwagen zoals hij is.
            const now = await this.cart(this.cartEndpoint(changeUrl), 8000);
            if (!now || now.items.some((item) => item && item.key === key)) throw new Error(await this.describe(removed));
          }
          window.location.reload();
        } catch (error) {
          this.readding = false;
          link.removeAttribute('aria-busy');
          const reason = error instanceof Error && error.message ? ` ${error.message}` : '';
          if (status) status.textContent = `${block.dataset.failed || ''}${reason}`.trim();
          this.refresh();
        }
      }
      async describe(response) {
        try {
          const data = await response.json();
          return data && typeof data.description === 'string' ? data.description.trim() : '';
        } catch (error) {
          return '';
        }
      }
      // B1: dezelfde variant opnieuw toevoegen mét de route-eigenschap (zelfde body als de advisory-knop), daarna de
      // oude regel op key naar 0 (onafhankelijk van verschoven regelnummers) en herladen. Eerst toevoegen, dan
      // verwijderen: mislukt het toevoegen, dan staat de oude regel er nog en gaat niets verloren. Alleen als Shopify het
      // toevoegen weigert (bijv. de voorraadlimiet omdat de oude regel de voorraad vasthoudt) draait de volgorde om.
      // 22-09 (tabbladen): vóór de poging een verse /cart.js. Loopt deze pagina achter (de oude regel is al weg, heeft
      // een ander aantal, of er staat al een gestempeld exemplaar dat deze pagina niet kent), dan wordt er niets
      // toegevoegd en toont een herlaadbeurt de echte stand. Terugdraaien gebeurt alleen nog in settle().
      async readd(button, auto = false) {
        const line = button.closest('[data-native-legacy]');
        const block = button.closest('[data-native-legacy-block]');
        if (!line || !block || this.readding || this.dataset.commerceVersion !== 'er-native-advisory/1' || this.designMode()) return;
        if (this.saving || this.fields().some((field) => field.value !== field.defaultValue)) {
          this.say(this.status?.dataset.saving || '');
          return;
        }
        const status = line.querySelector('[data-native-legacy-status]');
        const variantId = line.dataset.nativeVariantId || '';
        const key = line.dataset.nativeKey || '';
        const quantity = Number(line.dataset.nativeQuantity);
        const addUrl = this.endpoint(block.dataset.addUrl, '/cart/add.js');
        const changeUrl = this.endpoint(block.dataset.changeUrl, '/cart/change.js');
        const cartUrl = this.cartEndpoint(changeUrl);
        if (!/^[1-9][0-9]*$/.test(variantId) || !Number.isSafeInteger(Number(variantId)) || key === '' || !Number.isSafeInteger(quantity) || quantity < 1 || !addUrl || !changeUrl || !cartUrl) return;
        this.readding = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        // 22-09: tijdens het herstel staat de vernieuwde regel even naast de oude. Afrekenen en de snelle
        // betaalknoppen zijn in dat venster niet klikbaar. 22-09 (tabbladen): de waakhond geeft niet meer vrij;
        // elk verzoek heeft een eigen tijdslimiet van 8 seconden (post/cart) en settle() beslist op een verse
        // stand. Blijft er ondanks dat iets hangen, dan herlaadt de pagina na 45 seconden: het liquid-blok is de
        // waarheid en sluit een dubbele regel zelf. Een herstelpoging mag afrekenen nooit permanent dichtzetten,
        // maar mag het ook nooit openzetten zolang de stand van de winkelwagen onbekend is.
        this.refresh();
        window.clearTimeout(this.readdTimer);
        this.readdTimer = window.setTimeout(() => window.location.reload(), 45000);
        const tell = (text) => { if (status) status.textContent = text; };
        tell(block.dataset.busy || '');
        const failed = block.dataset.failed || '';
        const failedRemove = block.dataset.failedRemove || failed;
        const finish = (outcome, text) => {
          window.clearTimeout(this.readdTimer);
          if (outcome === 'reload') { window.location.reload(); return; }
          if (outcome === 'reload-soon') { this.readdTimer = window.setTimeout(() => window.location.reload(), auto ? 1500 : 0); return; }
          this.readding = false;
          button.removeAttribute('aria-busy');
          if (outcome === 'duplicate') { this.duplicate = true; button.hidden = true; }
          else button.disabled = false;
          tell(text || '');
          this.refresh();
        };
        const ctx = { key, variantId, quantity, changeUrl, cartUrl, stampedBefore: 0, failed, failedRemove };
        const addBody = { items: [{ id: Number(variantId), quantity, properties: { _er_native_route: 'er-native-advisory/1' } }] };
        let removedFirst = false;
        try {
          const before = await this.cart(cartUrl, 8000);
          if (!before) throw new Error('');
          const seen = this.look(before, key, variantId);
          if (!seen.old || Number(seen.old.quantity) !== quantity || (seen.stampedQuantity > 0 && this.dataset.duplicate !== 'true')) {
            // De pagina loopt achter op de winkelwagen: niets toevoegen. Automatisch even wachten, zodat een ander
            // tabblad dat halverwege is zijn oude regel nog kan weghalen en de herlaadbeurt de nette stand toont.
            finish('reload-soon');
            return;
          }
          ctx.stampedBefore = seen.stampedQuantity;
          let added = null;
          try {
            added = await this.post(addUrl, addBody, 8000);
          } catch (error) {
            if (!this.timedOut(error)) throw error;
          }
          if (!added) {
            // Toevoegen na 8 seconden afgebroken: onbekend of het is geland. settle() kijkt in een verse stand en
            // maakt het herstel af, draait terug of laat alles staan - maar zet de knoppen niet open op een gok.
            const [outcome, text] = await this.settle(ctx, false);
            finish(outcome, text);
            return;
          }
          if (added.ok) {
            let removed = null;
            try {
              removed = await this.post(changeUrl, { id: key, quantity: 0 }, 8000);
            } catch (error) {
              removed = null;
            }
            if (removed && removed.ok) {
              // 22-09 (tabbladen): 200 bewijst niet dat DEZE poging de oude regel weghaalde. Shopify geeft ook 200
              // voor een sleutel die al weg is (gemeten 22-09 in de voorvertoning); met twee tabbladen staat het
              // aantal dan dubbel, mét stempel, en geen enkele veto ziet dat. Het antwoord is de winkelwagen zelf:
              // daarin moet de oude regel weg zijn en mag het gestempelde aantal niet boven één herstel uitkomen.
              const [outcome, text] = await this.afterRemove(ctx, removed);
              finish(outcome, text);
              return;
            }
            // Review 18-09 (B3): het onderdeel staat al opnieuw in de winkelwagen. Niet nog eens laten toevoegen
            // (dat verdubbelt het aantal). 22-09 (ongedaan maken): eerst terugdraaien - liever een klant die zelf
            // een knop indrukt dan een klant die dubbel betaalt. 22-09 (tabbladen): het terugdraaien rekent in
            // settle() met een verse /cart.js, niet met het antwoord van deze toevoeging. Is de oude regel
            // inmiddels door een ander tabblad opgeruimd, dan gaat alleen het overschot van deze poging eraf en
            // nooit de laatste regel; is hij er nog, dan gaat precies deze toevoeging weer weg.
            const [outcome, text] = await this.settle(ctx, true);
            finish(outcome, text);
            return;
          }
          if (added.status === 422) {
            const reason = await this.describe(added);
            // 22-09: de omgekeerde volgorde (eerst de oude regel weghalen) blijft aan een klik hangen. Een
            // automatische poging stopt hier en laat de winkelwagen precies zoals hij was; anders zou een
            // uitverkochte variant uit de winkelwagen verdwijnen zonder dat de klant erom vroeg.
            if (auto) throw new Error(reason);
            const removed = await this.post(changeUrl, { id: key, quantity: 0 }, 8000);
            if (!removed.ok) throw new Error(reason);
            removedFirst = true;
            added = await this.post(addUrl, addBody, 8000);
            if (!added.ok) throw new Error((await this.describe(added)) || reason);
          } else {
            // Review 18-09 (B2): tijdelijke fout (429/5xx): de oude regel blijft staan, opnieuw proberen kan.
            throw new Error(await this.describe(added));
          }
          finish('reload');
        } catch (error) {
          window.clearTimeout(this.readdTimer);
          this.readding = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          const reason = error instanceof Error && error.message ? ` ${error.message}` : '';
          tell(`${removedFirst ? block.dataset.failedRemoved || '' : failed}${reason}`.trim());
          this.refresh();
        }
      }
      // 22-09 (tabbladen): de enige plek die terugdraait of afmaakt, en die rekent uitsluitend met een VERSE /cart.js.
      // Regels: (1) alleen wat sinds de eigen meting aan gestempeld aantal bij kwam telt als "toegevoegd", en er gaat
      // nooit meer af dan deze poging zelf toevoegde (quantity); (2) staat de oude regel er nog, dan mag de nieuwe
      // regel terug naar 0, want de oude blijft; (3) is de oude regel weg, dan gaat alleen het overschot boven één
      // herstel eraf en blijft er altijd minstens één regel staan - een lege winkelwagen kan hier niet ontstaan;
      // (4) is de stand niet op te halen, dan blijft het slot dicht (dubbele regel, klant haalt de oude weg) of
      // toont een herlaadbeurt de waarheid - er wordt niets op een gok gewijzigd.
      // Uitkomsten: 'reload' (klaar of pagina liep achter), 'failed' (teruggedraaid, knop weer aan),
      // 'duplicate' (niet teruggedraaid: slot dicht tot de klant de rode regel weghaalt).
      async settle(ctx, addKnownOk) {
        const now = await this.cart(ctx.cartUrl, 8000);
        if (!now) return addKnownOk ? ['duplicate', ctx.failedRemove] : ['reload', ''];
        const seen = this.look(now, ctx.key, ctx.variantId);
        const grown = Math.max(0, seen.stampedQuantity - ctx.stampedBefore);
        if (seen.old) {
          if (!addKnownOk) {
            // Eigen toevoeging niet geland: er is niets veranderd, de bestaande knoppen en tekst volstaan.
            if (grown < ctx.quantity) return ['failed', ctx.failed];
            // Wel geland (of een gelijkwaardige van een ander tabblad): het herstel afmaken.
            let removed = null;
            try {
              removed = await this.post(ctx.changeUrl, { id: ctx.key, quantity: 0 }, 8000);
            } catch (error) {
              removed = null;
            }
            if (removed && removed.ok) return this.afterRemove(ctx, removed);
            return this.settle(ctx, true);
          }
          const share = Math.min(ctx.quantity, grown);
          if (share > 0 && seen.stampedKey !== '') {
            let back = null;
            try {
              back = await this.post(ctx.changeUrl, { id: seen.stampedKey, quantity: seen.stampedQuantity - share }, 8000);
            } catch (error) {
              back = null;
            }
            if (!back || !back.ok) return ['duplicate', ctx.failedRemove];
          }
          return ['failed', ctx.failed];
        }
        // De oude regel is weg: een ander tabblad (of een eerder verzoek van dit tabblad) heeft hem al opgeruimd.
        return this.trim(seen, ctx);
      }
      // 22-09 (tabbladen): na een geslaagd /cart/change.js (200) is het antwoord de winkelwagen zelf. Staat de oude
      // regel daar nog in, dan is het weghalen niet gelukt (als mislukt behandelen, op een verse stand). Is hij weg,
      // dan mag het gestempelde aantal niet boven één herstel uitkomen (trim). Zonder bruikbaar antwoord: verse stand.
      async afterRemove(ctx, response) {
        let after = null;
        try {
          const data = await response.json();
          after = data && Array.isArray(data.items) ? data : null;
        } catch (error) {
          after = null;
        }
        if (!after) return this.settle(ctx, true);
        const seen = this.look(after, ctx.key, ctx.variantId);
        if (seen.old) return this.settle(ctx, true);
        return this.trim(seen, ctx);
      }
      // De oude regel is weg. Precies één herstel hoort over te blijven: het gestempelde aantal van vóór deze poging
      // plus het aantal van de oude regel. Staat er meer (twee tabbladen voegden allebei toe en de tweede
      // verwijdering was een lege 200), dan gaat het overschot eraf - als vast aantal, zodat tabbladen die dit
      // allebei doen op hetzelfde uitkomen. Nooit onder dat aantal, dus nooit naar 0: een lege winkelwagen kan
      // hier niet ontstaan. Staat er minder, dan blijft dat zo (een ander tabblad was eerder).
      async trim(seen, ctx) {
        const target = ctx.stampedBefore + ctx.quantity;
        if (seen.stampedKey !== '' && seen.stampedQuantity > target) {
          try {
            await this.post(ctx.changeUrl, { id: seen.stampedKey, quantity: target }, 8000);
          } catch (error) {
            // de herlaadbeurt toont de stand; het liquid-blok sluit een dubbele regel zelf
          }
        }
        return ['reload', ''];
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-support-intro"]) return;
  try {
    
  class EarbudsRestoreHelpPart extends HTMLElement {
    connectedCallback() {
      if (this.partAbort) return;
      this.partAbort = new AbortController();
      this.partWindow = this.ownerDocument.defaultView;
      this.partWindow?.addEventListener('hashchange', () => this.renderPart(), { signal: this.partAbort.signal });
      this.renderPart();
    }

    disconnectedCallback() {
      this.partAbort?.abort();
      this.partAbort = null;
    }

    renderPart() {
      const output = this.querySelector('[data-er-help-part-label]');
      const hash = this.partWindow?.location.hash || '';
      const labels = {
        '#er-part=earbud_L': this.dataset.labelLeft,
        '#er-part=case': this.dataset.labelCase,
        '#er-part=earbud_R': this.dataset.labelRight,
      };
      const label = Object.hasOwn(labels, hash) ? labels[hash] : '';
      if (output) output.textContent = label || '';
      this.hidden = !output || !label;
    }
  }

  if (!customElements.get('er-help-part')) {
    customElements.define('er-help-part', EarbudsRestoreHelpPart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-upsell-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-upsell-set')) {
    class ERUpsellSet extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.onClick = (event) => {
          const button = event.target.closest('[data-er-upsell-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.addToCart(button);
        };
        this.addEventListener('click', this.onClick);

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.refresh(event));
        }

        // W3 (19-09): op de advisory-productpagina komt geen variantChange (Dawn's variantkiezer rendert daar niet).
        // De keuze staat in de native select van er-native-advisory-product; volg die, zodat de andere kant en de
        // case de gekozen uitvoering en conditie krijgen. De select wordt alleen gelezen, nooit gezet.
        this.shownVariant = this.getAttribute('data-er-upsell-variant') || '';
        // I2.49: bij één variant valt er niets te kiezen; geen volger (anders elke lading een extra sectieverzoek).
        this.variantSelect = this.hasAttribute('data-er-upsell-single')
          ? null
          : document.querySelector('er-native-advisory-product [data-native-variant]');
        if (this.variantSelect) {
          this.onVariantSelect = () => this.follow(this.variantSelect.value);
          this.variantSelect.addEventListener('change', this.onVariantSelect);
          // Review 19-09 (R2): een landing met ?variant= toont kaarten voor een keuze die de klant nog niet maakte;
          // zolang de native select leeg is, verversen zonder variant (alleen accessoires, geen onderdelen).
          if (this.variantSelect.value === '' && this.shownVariant !== '') this.follow('');
        }
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        if (this.variantSelect && this.onVariantSelect) this.variantSelect.removeEventListener('change', this.onVariantSelect);
        this.variantSelect = null;
        this.bound = false;
      }

      // Alleen een geheel getal als variant-id; al het andere telt als "geen keuze".
      follow(value) {
        const text = String(value || '');
        const id = /^[1-9][0-9]*$/.test(text) && Number.isSafeInteger(Number(text)) ? text : '';
        if (id === this.shownVariant) return;
        this.shownVariant = id;
        // Review 19-09 (R3): onderdeelkaarten van de vorige keuze meteen weg; apply() zet de juiste terug.
        this.querySelectorAll('.er-upsell-set__card--part').forEach((card) => card.remove());
        this.load(id);
      }

      load(variantId) {
        const sectionId = this.getAttribute('data-er-upsell-section') || '';
        if (!/^[A-Za-z0-9_-]+$/.test(sectionId)) return;
        const params = new URLSearchParams();
        if (variantId) params.set('variant', variantId);
        params.set('section_id', sectionId);
        this.ticket = (this.ticket || 0) + 1;
        const ticket = this.ticket;
        // 18-10-2026 (ronde T, AP5-overal): een AirPods 5-regel uit de kiezer van het keuzeproduct (data-er-extra, eigen product) haalt
        // dezelfde sectie op het pad van dat product op, met de kaarten van zijn eigen productpagina; anders het pad van deze pagina.
        const keuze = variantId && this.variantSelect
          ? Array.from(this.variantSelect.options).find((option) => option.value === variantId) || null
          : null;
        const eigen = keuze && keuze.dataset.erExtra === 'ap5' && /^\/[^?#]*$/.test(keuze.dataset.erExtraUrl || '')
          ? keuze.dataset.erExtraUrl
          : window.location.pathname;
        fetch(`${eigen}?${params.toString()}`, { headers: { Accept: 'text/html' } })
          .then((response) => (response.ok ? response.text() : null))
          .then((html) => {
            if (ticket !== this.ticket) return; // een nieuwere keuze is onderweg
            if (html === null || !this.apply(html)) this.shownVariant = null; // volgende change probeert opnieuw
          })
          .catch(() => {
            // Alleen het verversen van de kaarten; de bestaande kaarten blijven staan en werken.
            if (ticket === this.ticket) this.shownVariant = null;
          });
      }

      // Neemt de kaarten over uit de sectie-HTML van dezelfde herkomst, als DOM-knopen (geen innerHTML).
      apply(html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('er-upsell-set');
        if (!fresh) return false;
        this.replaceChildren(...Array.from(fresh.childNodes, (node) => document.importNode(node, true)));
        this.hidden = fresh.hasAttribute('hidden');
        return true;
      }

      addToCart(button) {
        const variantId = button.getAttribute('data-er-variant-id');
        if (!variantId || button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.say('', false);

        const cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              };

        const body = { id: Number(variantId), quantity: 1, properties: { _er_native_route: 'er-native-advisory/1' } };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(body);

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
          .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
          .then(({ ok, data }) => {
            // GX/B2: een Shopify-fout komt als JSON met status/description; die is nu zichtbaar, niet stil.
            if (!ok || !data || data.status) {
              this.fail(button, data);
              return;
            }
            this.succeed(button);
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'er-upsell-set',
                productVariantId: variantId,
                cartData: data,
              });
            }
            this.updateCount();
          })
          .catch(() => this.fail(button, null));
      }

      say(text, isError) {
        const status = this.querySelector('[data-er-upsell-status]');
        if (!status) return;
        status.textContent = text;
        status.classList.toggle('is-error', !!isError && text !== '');
      }

      // GX/B2: knop "Toegevoegd ✓" (blijft uitgeschakeld: één klik = één stuk), link naar de winkelwagen zichtbaar,
      // statusregel met de bestaande locale-tekst "Toegevoegd. Controleer ...".
      succeed(button) {
        button.removeAttribute('aria-busy');
        button.classList.add('is-added');
        const label = button.querySelector('[data-er-upsell-label]');
        if (label && this.dataset.addedText) label.textContent = this.dataset.addedText;
        const card = button.closest('.er-upsell-set__card');
        const link = card ? card.querySelector('[data-er-upsell-cart-link]') : null;
        if (link) link.hidden = false;
        this.say(this.dataset.addedNotice || '', false);
      }

      fail(button, data) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        const description = data && typeof data.description === 'string' ? data.description.trim() : '';
        this.say(`${description || this.dataset.errorText || ''} ${this.dataset.uncertainText || ''}`.trim(), true);
      }

      // GX/B2: de teller in de header bijwerken via /cart.js. Alleen als het bestaande tellerelement er staat; de
      // header rendert het niet bij een lege winkelwagen, dan wordt deze stap overgeslagen (opdracht 18-09).
      updateCount() {
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!bubble) return;
        fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (!data || !Number.isInteger(data.item_count)) return;
            const count = data.item_count;
            const visible = bubble.querySelector('[aria-hidden="true"]');
            if (visible && count < 100) visible.textContent = String(count);
            const spoken = bubble.querySelector('.visually-hidden');
            const template = count === 1 ? this.dataset.countOne : this.dataset.countOther;
            if (spoken && template) spoken.textContent = template.replace(/\d+/, String(count));
          })
          .catch(() => {});
      }

      refresh(event) {
        const sectionId = this.getAttribute('data-er-upsell-section');
        const variant = event && event.data && event.data.variant;
        if (!sectionId) return;
        if (!variant || !variant.id || !/^[1-9][0-9]*$/.test(String(variant.id))) {
          this.textContent = '';
          this.hidden = true;
          return;
        }

        fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId))
          .then((response) => response.text())
          .then((html) => {
            if (!this.apply(html)) {
              this.textContent = '';
              this.hidden = true;
            }
          })
          .catch(() => {
            // Alleen het verversen van de kaarten na een variantwissel; de bestaande kaarten blijven staan en
            // werken. Er is hier niets dat de klant moet weten of doen.
          });
      }
    }

    customElements.define('er-upsell-set', ERUpsellSet);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  if (window.__erCookiePreferencesBound) return;
  window.__erCookiePreferencesBound = true;
  var RETRY_MS = 200;
  var DEADLINE_MS = 5000;
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-er-cookie-preferences]');
    if (!button || button.disabled || window.__erCookiePreferencesInFlight) return;
    if (window.Shopify && window.Shopify.designMode) {
      var editorStatus = button.parentElement.querySelector('[data-er-cookie-preferences-status]');
      if (editorStatus) editorStatus.textContent = button.dataset.editorNotice;
      return;
    }
    window.__erCookiePreferencesInFlight = true;
    var status = button.parentElement ? button.parentElement.querySelector('[data-er-cookie-preferences-status]') : null;
    var retryTimer = null;
    var deadlineTimer = null;
    var finished = false;
    button.disabled = true;
    if (status) status.textContent = button.dataset.opening;
    function finish(ok) {
      if (finished) return;
      finished = true;
      if (retryTimer !== null) clearTimeout(retryTimer);
      if (deadlineTimer !== null) clearTimeout(deadlineTimer);
      window.__erCookiePreferencesInFlight = false;
      button.disabled = false;
      if (!button.isConnected) return;
      if (status) status.textContent = ok ? '' : button.dataset.unavailable;
    }
    deadlineTimer = setTimeout(function () { finish(false); }, DEADLINE_MS);
    function attempt() {
      if (finished) return;
      if (!button.isConnected) {
        finish(false);
        return;
      }
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        try {
          Promise.resolve(window.privacyBanner.showPreferences()).then(
            function () { finish(true); },
            function () { finish(false); }
          );
        } catch (error) {
          finish(false);
        }
      } else {
        retryTimer = setTimeout(attempt, RETRY_MS);
      }
    }
    attempt();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
